export default "__VITE_PUBLIC_ASSET__26bf421c__"